import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/withdrawal-methods/useWithdrawalMethodQueryKeys.ts
var t = e("withdrawal-methods", {
	forWorkspace: (e) => ["workspace", e],
	detail: (e) => ["detail", e]
});
//#endregion
export { t as withdrawalMethodQueryKeys };
